import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import BridgeBook from "../book/bridge-book";
import BookGrid from "../bookviews/book-grid";
import DefaultSearchContainer from "./search-container/default-search-container";
import NativeSearchContainer from "./search-container/native-search-container";
import TopReadsContainer from "./top-reads-container";
import {
  actions as bridgeActions,
  selectors as bridgeSelectors
} from "../../../../redux/bridge";
import { actions as modalActions } from "../../../../redux/modals";
import { selectors as licenseSelectors } from "../../../../redux/license";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { actions as routerActions } from "../../../../redux/router";
import {
  styledMedia,
  withAllMatches
} from "../../../components/mediaquery/breakpoints";
import { EDGE_SPACING, EDGE_SPACING_MED } from "../bookviews/consts";
import HeroSplash from "./hero-splash";
import { t } from "../../../core/translate";
import PageTitle from "../../../utils/page-title";
import RecommendBySubjectLanes from "./lanes/recommend-by-subject";
import BrandedSubscriptionLanes from "./lanes/branded-subscriptions";
import { trendParams } from "../../../../redux/bridge/utils";
import SmallSubscriptions from "./small-subscriptions";
import PopularLane from "./lanes/popular";
import RecentlyAddedLane from "./lanes/recently-added";
import RecommendedLane from "./lanes/recommended";
import LargeBrandedSubscriptionView from "./large-branded-subscription-view";

const Styled = {
  HeroContentCentered: styled.div`
    margin: 0 auto;
    padding: 64px ${EDGE_SPACING}px 36px ${EDGE_SPACING}px;
    max-width: 1258px;
    position: relative;
    z-index: 1;

    ${styledMedia.medium`
      padding: 26px ${EDGE_SPACING_MED}px 32px ${EDGE_SPACING_MED}px;
    `}

    ${styledMedia.small`
      padding: 0;
    `}

    /* Search container will take care of this */
    ${props => props.native && `padding-top: 0 !important`}
  `,
  HeroTitleContainer: styled.div`
    margin-bottom: 10px;
  `
};
class SubscriptionsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridAssets: null,
      showSmallSubSearch: false,
      headerLabel: "",
      fullSubscriptionViewVbid: null,
      subscriptionAssets: null
    };
    this.collapseView = this.collapseView.bind(this);
    this.expandSwimlane = this.expandSwimlane.bind(this);
    this.showAllSubscriptions = this.showAllSubscriptions.bind(this);
  }

  componentDidMount() {
    this.fetchLists(this.brandedListParams());
  }

  componentDidUpdate(prevProps) {
    if (!this.props.licenseUpdating && prevProps.licenseUpdating) {
      this.fetchLists(this.brandedListParams());
    }
  }

  fetchLists(params) {
    this.props.fetchLists(params);
  }

  brandedListParams() {
    const {
      popularSwimlaneEnabled,
      recommendedSwimlaneEnabled,
      addedSwimlaneEnabled
    } = this.props;
    const listsToFetch = [];
    if (popularSwimlaneEnabled) {
      listsToFetch.push(trendParams("popular"));
    }
    if (recommendedSwimlaneEnabled) {
      listsToFetch.push(trendParams("recommended"));
    }
    if (addedSwimlaneEnabled) {
      listsToFetch.push(trendParams("added"));
    }
    return listsToFetch;
  }

  expandSwimlane(assets, headerLabel) {
    this.setState({
      gridAssets: assets,
      headerLabel: headerLabel
    });
  }

  collapseView() {
    this.setState({ gridAssets: null });
  }

  showAllSubscriptions() {
    this.props.routePush("explore");
    this.setState({
      fullSubscriptionViewVbid: null,
      subscriptionAssets: null
    });
  }

  renderHeroSplash() {
    const {
      popularSwimlaneEnabled,
      recommendedSwimlaneEnabled,
      showTopPopular,
      showTopRecommended
    } = this.props;
    if (
      (popularSwimlaneEnabled && showTopPopular) ||
      (recommendedSwimlaneEnabled && showTopRecommended)
    ) {
      // If native, the search container handles the splash
      const { isMedium, native } = this.props;
      if (!isMedium && !native) {
        return (
          <HeroSplash leftHeight={210} rightHeight={328} widthBasis={1440} />
        );
      }
    }
    return null;
  }

  renderHeroContent(trendingCount) {
    const {
      popularSwimlaneEnabled,
      recommendedSwimlaneEnabled,
      showTopPopular,
      showTopRecommended,
      popularTitleKey,
      native,
      popular,
      recommended,
      popularLoading,
      recommendedLoading
    } = this.props;

    if (
      (popularSwimlaneEnabled && showTopPopular) ||
      (recommendedSwimlaneEnabled && showTopRecommended)
    ) {
      return (
        <Styled.HeroContentCentered native={native}>
          <TopReadsContainer
            onViewAll={() => this.expandSwimlane(popular, t(popularTitleKey))}
            popular={popular.slice(0, trendingCount)}
            recommended={recommended ? recommended[0] : null}
            loading={popularLoading || recommendedLoading}
          />
        </Styled.HeroContentCentered>
      );
    }
    return null;
  }

  renderSubscriptionOverviewLanes = () => {
    return (
      // show lanes defined for this subscription
      <BrandedSubscriptionLanes
        expandSwimlane={e => this.props.routePush(`/explore/${e}`)}
      />
    );
  };

  render() {
    const {
      gridAssets,
      headerLabel,
      fullSubscriptionViewVbid,
      subscriptionAssets,
      displayMode
    } = this.state;
    const {
      added,
      addedLoading,
      addedSwimlaneEnabled,
      addedTitleKey,
      allAssets,
      allAssetsLoading,
      isMedium,
      isSmall,
      native,
      popular,
      popularLoading,
      popularSwimlaneEnabled,
      popularTitleKey,
      recommended,
      recommendedLoading,
      recommendedSwimlaneEnabled,
      recommendedTitleKey,
      showTopPopular,
      showTopRecommended,
      subscriptionVbid
    } = this.props;
    const subscriptionViewVbid = subscriptionVbid || fullSubscriptionViewVbid;
    const pageTitle = gridAssets
      ? t("explore.explore-category", "Explore Category", {
          category: headerLabel
        })
      : t("page.explorer", "Explore");

    if (gridAssets) {
      return (
        <BookGrid
          BookObject={BridgeBook}
          onHeaderClick={this.collapseView}
          isbns={gridAssets.map(b => ({ isbn: b.vbid }))}
          headerLabel={headerLabel}
          count={gridAssets.length}
          backArrow={t("page.explorer", "Explore")}
        />
      );
    } else if (subscriptionViewVbid) {
      if (subscriptionAssets && displayMode === "GRID") {
        return (
          <SmallSubscriptions
            subscriptionVbid={subscriptionViewVbid}
            allAssetsLoading={allAssetsLoading}
            assets={subscriptionAssets || allAssets}
            backToExplore={this.showAllSubscriptions}
          />
        );
      }
      return (
        <LargeBrandedSubscriptionView
          subscriptionVbid={subscriptionViewVbid}
          backToExplore={this.showAllSubscriptions}
        />
      );
    } else {
      let trendingCount = isMedium && !isSmall ? 6 : 3;
      if (!showTopPopular) {
        trendingCount = 0;
      }
      return (
        <div>
          <PageTitle title={pageTitle} key="title" />
          {this.renderHeroSplash()}
          {native && <NativeSearchContainer />}
          {this.renderHeroContent(trendingCount)}
          {recommendedSwimlaneEnabled && (
            <RecommendedLane
              swimlaneStart={showTopRecommended ? 1 : 0}
              recommendedLoading={recommendedLoading}
              recommended={recommended}
              recommendedTitleKey={recommendedTitleKey}
              expandSwimlane={this.expandSwimlane}
            />
          )}
          {!native && <DefaultSearchContainer />}
          {popularSwimlaneEnabled && (
            <PopularLane
              popularTitleKey={popularTitleKey}
              popular={popular}
              popularLoading={popularLoading}
              expandSwimlane={this.expandSwimlane}
              trendingCount={trendingCount}
            />
          )}
          {addedSwimlaneEnabled && (
            <RecentlyAddedLane
              addedLoading={addedLoading}
              addedTitleKey={addedTitleKey}
              added={added}
              expandSwimlane={this.expandSwimlane}
            />
          )}
          {/* show a lane for each branded subscription */}
          {this.renderSubscriptionOverviewLanes()}
          <RecommendBySubjectLanes expandSwimlane={this.expandSwimlane} />
        </div>
      );
    }
  }
}

const mapStateToProps = (state, props) => ({
  allAssetsLoading: bridgeSelectors.isAssetsFetching(
    state,
    trendParams("all", props.subscriptionVbid)
  ),
  allAssets: bridgeSelectors.getAssets(
    state,
    trendParams("all", props.subscriptionVbid)
  ),
  licenseUpdating: licenseSelectors.isLicenseUpdating(state),
  popularSwimlaneEnabled: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.popular"
  ),
  popularTitleKey: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.popularTitleKey",
    "explore.trending"
  ),
  showTopPopular: brandSelectors.getBrandValue(
    state,
    "Subscriptions.TopReads.showTopPopular",
    true
  ),
  recommendedSwimlaneEnabled: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.recommended"
  ),
  recommendedTitleKey: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.recommendedTitleKey",
    "explore.top-picks"
  ),
  showTopRecommended: brandSelectors.getBrandValue(
    state,
    "Subscriptions.TopReads.showTopRecommended",
    true
  ),
  addedSwimlaneEnabled: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.added"
  ),
  recommended: bridgeSelectors.getAssets(state, trendParams("recommended")),
  recommendedLoading: bridgeSelectors.isAssetsFetching(
    state,
    trendParams("recommended")
  ),
  popular: bridgeSelectors.getAssets(state, trendParams("popular")),
  popularLoading: bridgeSelectors.isAssetsFetching(
    state,
    trendParams("popular")
  ),
  added: bridgeSelectors.getAssets(state, trendParams("added")),
  addedTitleKey: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.addedTitleKey",
    "explore.recently-added"
  ),
  addedLoading: bridgeSelectors.isAssetsFetching(state, trendParams("added"))
});

const mapDispatchToProps = dispatch => ({
  fetchLists: lists => dispatch(bridgeActions.fetchLists(lists)),
  openRedeemModal: () => dispatch(modalActions.openRedeemModal()),
  routePush: path => dispatch(routerActions.push(path))
});

export default withAllMatches(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(SubscriptionsView))
);
